import { getData, postData } from '@/assets/js/api.js'

// 查询场景列表
export const FindSceneList = (params, fn) => {
  const methods = '/api/Scene/FindSceneList'
  getData(methods, params, 1, fn)
}
// 查询场景列表
export const FindSceneListByPage = (params, fn) => {
  const methods = '/api/Scene/FindSceneListByPage'
  return getData(methods, params, 1, fn)
}

// 查询场景配置详情
export const FindScene = (params, fn) => {
  const methods = '/api/Scene/FindScene'
  return getData(methods, params, 1, fn)
}

// 执行场景
export const Call = (params, fn) => {
  const methods = '/api/Scene/Call'
  return getData(methods, params, 1, fn)
}
export const CallScene = (params, fn) => {
  Call(params, fn)
}

// 删除场景
export const Delete = (params, fn) => {
  const methods = '/api/Scene/Delete'
  return getData(methods, params, 1, fn)
}

// 批量删除场景
export const GroupDelete = (params, fn) => {
  const methods = '/api/IFTTT/BatchRemove'
  return postData(methods, params, 1, fn)
}

// 添加场景
export const Create = (params, fn) => {
  const methods = '/api/Scene/Create'
  return postData(methods, params, 1, fn);
}

// 添加场景2
export const CreateForControlDevice = (params, fn) => {
  const methods = '/api/Scene/CreateForControlDevice'
  return postData(methods, params, 1, fn);
}


// 编辑场景
export const Edit = (params, fn) => {
  const methods = '/api/Scene/Edit'
  return postData(methods, params, 1, fn)
}

// 历史场景看板
export const ShowSceneHistorySyncResult = (params, fn) => {
  const methods = '/api/Scene/ShowHistorySyncResult'
  getData(methods, params, 1, fn)
}

// 当前看板
export const ShowSceneCurrentSyncResult = (params, fn) => {
  const methods = '/api/Scene/ShowCurrentSyncResult'
  getData(methods, params, 1, fn)
}

// 重新下发配置
export const ReSyncDeviceConfig = (params, fn) => {
  const methods = '/api/Scene/ReSyncDeviceConfig'
  getData(methods, params, 1, fn)
}

// 获取最后一次执行场景
export const GetLastScene = (params, fn) => {
  const methods = '/api/SysAndDeviceLog/GetTheLastestCallIftttLog'
  getData(methods, params, 1, fn)
}

// 获取模版
export const GetTemplateList = (params, fn) => {
  const methods = '/businessapi/AutoTemplate/GetSceneTemplateList'
  getData(methods, params, 1, fn)
}
// 获取模版设备列表
export const GetTemplateDevicesList = (params, fn) => {
  const methods = '/businessapi/AutoTemplate/GetSceneTemplateWithDeviceList'
  getData(methods, params, 1, fn)
}


// 用于图片场景mark4
export const SaveOrUpdateCustomData = (params, fn) => {
  const methods = '/businessapi/Common/SaveOrUpdateCustomData';

  return postData(methods, params, 1, fn);
}

// 获取图片场景mark4
export const GetCustomDataList = (params, fn) => {
  const methods = '/businessapi/Common/GetCustomDataList';

  return getData(methods, params, 1, fn);
}

//获取设备支持自动化3.0情况【现有接口】
export const GetDeviceSupportFunctions = (params, fn) => {
  const methods ='/api/device/GetDeviceSupportFunctions'

  return postData(methods, params, 1, fn);
}

// 转码
export const CreateMasterSceneBin = (params, fn) => {
  const methods ='/api/Scene/CreateMasterSceneBin';

  return postData(methods, params, 1, fn);
}

export const SceneRecoverDetail = (params, fn) => {
  const methods ='/businessapi/Scene/SceneRecoverDetail';

  return getData(methods, params, 1, fn);
}

// 恢复场景
export const sceneRecover = (params, fn) => {
  const methods ='/api/Scene/Recover';

  return postData(methods, params, 1, fn);
}



// 1 businessapi/Common/GetCustomDataList  httpget
// string projectCode, string type, long? identifier
// 2 businessapi/Common/SaveOrUpdateCustomData httppost
//    public class CustomDataDto
//     {
//         public string ProjectCode { get; set; }
//         public string Type { get; set; }
//         public long Identifier { get; set; }
//         public string? Content { get; set; }
//     }